import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { postAsync } from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import { z } from 'zod';
import BannerImg from '../../../../public/assets/images/BannersFiles/31.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import './Module.About.css';

const Contact = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: '',
  });
  
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const form = useRef();

  const formSchema = z.object({
    name: z.string().min(1, 'Full Name is required'),
    email: z.string().email('Email is required'),
    phone: z.string().regex(/^\+971\d{7,}$/, 'Your mobile number should starts with +971.'),
    subject: z.string().min(1, 'Subject is required'),
    message: z.string().min(1, 'Message is required'),
  });

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({ ...formErrors, [name]: '' });
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    // 👇 Validate form
    const result = formSchema.safeParse(formData);

    if (!result.success) {
      const newErrors = {};
      result.error.errors.forEach((err) => {
        newErrors[err.path[0]] = err.message;
      });
      setFormErrors(newErrors);
      return;
    }

    try {
      const encodedBody = encodeURIComponent(JSON.stringify(formData));
      const response = await postAsync(
        `APIClient/ContactUs?subject=${encodeURIComponent('Contact Us')}&body=${encodedBody}`,
      );

      if (response.statusCode === 200) {
        toast.success(t('Email sent successfully'));
      }
    } catch (error) {
      console.log(error);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };
  const emiratesAPIData = [
    { en_US: 'Complaints', ar_SA: 'شكوى', emiratesID: '1' },
    { en_US: 'Help', ar_SA: 'طلب مساعدة', emiratesID: '2' },
    { en_US: 'Inquiry', ar_SA: 'استفسار ', emiratesID: '3' },
    { en_US: 'Suggestion', ar_SA: 'اقتراحات', emiratesID: '4' },
  ];

  useEffect(() => {
    localStorage.setItem('isHome', true);
  }, []);

  const contact = [
    {
      id: 1,
      title: 'Our Location',
      content: 'Sheikh Rashid Bin Saqr Al Qasimi Street, Samnan, Sharjah',
    },
    {
      id: 2,
      title: 'Phone Number',
      content: '80014',
    },
    {
      id: 3,
      title: 'Email',
      content: 'info@shjc.sharjah.ae',
    },
  ];

  return (
    <div className="">
      <StaticBanner BannerImg={BannerImg} en_US={'Contact'} arabic={false} />
      <section className="p-10 ">
        <div className="grid lg:grid-cols-3 md:grid-cols-2  grid-cols-1 gap-4 ">
          {contact?.map((data, index) => {
            return (
              <div className="">
                <div key={index} className="flex flex-col h-72 items-center p-10 bg-gray-200 rounded-3xl">
                  <div className="w-24 h-24 mb-3 rounded-full shadow-lg bg-white text-customorange text-center font-semibold pt-2 ">
                    {data.id == 1 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.0"
                        width="71pt"
                        height="98.000000pt"
                        viewBox="0 0 22 46"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g fill="#1b7a57" stroke="none">
                          <path d="M12 1c-3.148 0-6 2.553-6 5.702 0 3.148 2.602 6.907 6 12.298 3.398-5.391 6-9.15 6-12.298 0-3.149-2.851-5.702-6-5.702zm0 8c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm8 6h-3.135c-.385.641-.798 1.309-1.232 2h3.131l.5 1h-4.264l-.344.544-.289.456h.558l.858 2h-7.488l.858-2h.479l-.289-.456-.343-.544h-2.042l-1.011-1h2.42c-.435-.691-.848-1.359-1.232-2h-3.135l-4 8h24l-4-8zm-12.794 6h-3.97l1.764-3.528 1.516 1.528h1.549l-.859 2zm8.808-2h3.75l1 2h-3.892l-.858-2z" />
                        </g>
                      </svg>
                    ) : data.id == 2 ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.0"
                        width="71pt"
                        height="98.000000pt"
                        viewBox="0 0 22 46"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g fill="#1b7a57" stroke="none">
                          <path d="M14.89 23.654c-7.367 3.367-18.802-18.86-11.601-22.615l2.107-1.039 3.492 6.817-2.082 1.026c-2.189 1.174 2.37 10.08 4.609 8.994.091-.041 2.057-1.007 2.064-1.011l3.521 6.795c-.008.004-1.989.978-2.11 1.033zm-1.538-13.409l2.917.87c.223-.747.16-1.579-.24-2.317-.399-.739-1.062-1.247-1.808-1.469l-.869 2.916zm1.804-6.058c1.551.462 2.926 1.516 3.756 3.051.831 1.536.96 3.263.498 4.813l-1.795-.535c.325-1.091.233-2.306-.352-3.387-.583-1.081-1.551-1.822-2.643-2.146l.536-1.796zm.95-3.187c2.365.705 4.463 2.312 5.729 4.656 1.269 2.343 1.466 4.978.761 7.344l-1.84-.548c.564-1.895.406-4.006-.608-5.882-1.016-1.877-2.696-3.165-4.591-3.729l.549-1.841z" />
                        </g>
                      </svg>
                    ) : (
                      data.id == 3 && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.0"
                          width="71pt"
                          height="98.000000pt"
                          viewBox="0 0 22 46"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <g fill="#1b7a57" stroke="none">
                            <path d="M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z" />
                          </g>
                        </svg>
                      )
                    )}
                  </div>
                  <h5 className="mb-1  text-xl font-medium text-black ">{`${t(data?.title)}`}</h5>
                  <h6 className="py-2 text-black text-center  whitespace-normal">{`${t(data?.content)}`}</h6>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <section className="contact-section ">
        <div className="outer-container flex flex-col">
          <div className="form-column flex w-full">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3032.123249201723!2d55.417084236436295!3d25.343735203880716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f596bf84d56a1%3A0x1f560b9dcfdaecfb!2sSharjah%20Charity%20International!5e0!3m2!1sen!2sae!4v1637826793291!5m2!1sen!2sae"
              width="100%"
              height={300}
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            />
          </div>
          <div className="form-column flex  ">
            <div className="inner clearfix">
              <div className="sec-title text-center centered max-[600px]:w-full">
                <h2 className="sm:text-3xl  pt-4 sm:py-6 font-semibold">
                  {t('Contact Us .. If You Have Any Question')}
                </h2>
                <div className="sm:text-2xl  font-medium py-2 sm:py-6">
                  {t('We Will Call Back To Answer All Of Your Concerns')}
                </div>
              </div>
              {/* Contact Form*/}
              <div className="contact-form py-10">
                <form ref={form} onSubmit={sendEmail} id="contact-form" action="/Contact" noValidate="novalidate">
                  <div className="row ">
                    <div className="col-md-6 col-sm-12  form-group">
                      <input
                        type="text"
                        id="Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder={t('Name')}
                        data-val-required="The FULL NAME field is required."
                        className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                      />
                      {formErrors.name && <p className="text-red-600 text-sm mt-1">{`${t(formErrors.name)}`}</p>}
                    </div>
                    <div className="col-md-6 col-sm-12 form-group">
                      <input
                        id="Email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder={t('Email')}
                        data-val-email="Invalid Email Address"
                        data-val-regex="Invalid Email Address"
                        data-val-regex-pattern="^[a-zA-Z0-9_\.-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$"
                        data-val-required="The EMAIL field is required."
                        className="form-control border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                      />
                      {formErrors.email && <p className="text-red-600 text-sm mt-1">{`${t(formErrors.email)}`}</p>}
                    </div>
                    <div className="col-md-6 col-sm-12   form-group">
                      <input
                        id="Phone"
                        type="text"
                        className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                        placeholder={t('Phone Number')}
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        onInput={(event) => {
                          const { value } = event.target;
                          const regex = /^\+?\d*$/;

                          if (regex.test(value)) {
                          } else {
                            event.target.value = value.slice(0, -1);
                          }
                        }}
                      />
                      {formErrors.phone && <p className="text-red-600 text-sm mt-1">{`${t(formErrors.phone)}`}</p>}
                      {/* <span className="mt-2 text-sm">{t('Your mobile number should starts with +971.')}</span> */}
                    </div>

                    <div className="col-md-6 col-sm-12 form-group">
                      <select
                        // value={ selectedEmiratesID }
                        // onChange={ (selectedEmiratesID) => handleOnSelectEmirate(selectedEmiratesID) }
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                      >
                        <option value="0">--{t('Please Choose')}--</option>
                        {emiratesAPIData && emiratesAPIData.length > 0 ? (
                          emiratesAPIData?.map((item) => (
                            <option key={item.emiratesID} value={isActive ? item?.ar_SA : item?.en_US}>
                              {t(isActive ? item?.ar_SA : item?.en_US)}
                            </option>
                          ))
                        ) : (
                          <option>{t('No found')}</option>
                        )}
                      </select>
                      {formErrors.subject && <p className="text-red-600 text-sm mt-1">{`${t(formErrors.subject)}`}</p>}
                    </div>
                    <div className="col-md-12 col-sm-12 form-group">
                      <textarea
                        id="Message"
                        className=" border border-customgreen focus:ring-customgreen text-gray-900 text-sm rounded-lg  block w-full p-2.5"
                        placeholder={t('Message')}
                        data-val="true"
                        data-val-required="The MESSAGE field is required."
                        defaultValue={''}
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                      {formErrors.message && <p className="text-red-600 text-sm mt-1">{`${t(formErrors.message)}`}</p>}
                    </div>
                    <div className="col-md-12 col-sm-12 form-group text-center">
                      <button
                        className="text-white bg-customorange hover:bg-customorange/90 focus:ring-4 focus:outline-none focus:ring-customorange/90  font-medium rounded-3xl text-sm px-5 py-2.5 text-center inline-flex items-center  me-2 mb-2"
                        type="submit"
                        name="submit-form"
                      >
                        <span className="btn-title">{t('Send')}</span>
                      </button>
                    </div>
                  </div>
                  {/* <input
                    name="__RequestVerificationToken"
                    type="hidden"
                    defaultValue="CfDJ8FRz6rJzo0BLpKsvB6DfhPfhoxLWkHHbyu3Y2FktsV7SKI-Ikxp6FypEIhWal-5x-BMTKYZSPtYzqV05MK6K264W_9Qm1m0X3V8L1no6aNE12FH4l3IIATkeCgYip3dc7WaqcIjuVwzbMrNNwsW7KK4"
                  /> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
